module.exports = __webpack_public_path__ + "static/media/incendio.bb404ca9.svg";